import React, {useEffect, useState} from 'react'
import DHSelect from "../../general/DHSelect";
import ConfigUtil from "../../../util/ConfigUtil";
import FetchUtil from "../../../util/FetchUtil";


export default function SelectRegionComp({eventOperatorId, refreshCounter, regionId, onError, onChange}) {

    const [regionen, setRegionen] = useState([]);

    useEffect(() => {
        ladeDaten();
    }, [refreshCounter]);

    const ladeDaten = () => {
        let url = ConfigUtil.getConfig().resourceUrls.league + "/regionen/" + eventOperatorId;
        FetchUtil.fetchPost(url,
            {},
            json => {
                setRegionen(json);
            },
            responseNotOk => {
                onError("Fehler: " + responseNotOk.message);
            },
            error => {
                onError("Fehler: " + error.message)
            });
    }

    const getModel = () => {
        let rows = [];
        for (const element of regionen) {
            rows.push({id: element.id, value: element.bezeichnung});
        }
        return rows;
    }

    return <DHSelect width={200} value={regionId} onChange={(id) => onChange(id)} id={"id-region"} label="Region" model={getModel()}/>
}
